import { portalApi } from '../../redux/api/portalApi';

const queues = new WeakMap();
export function serializePanelSave(dispatch, key, save) {
  const scope = () => dispatch((_, getState) => {
    const state = getState();
    return JSON.stringify([state.user?.userDetails?.localAccountId || state.user?.userDetails?.username,
      state.apiUrls?.urls?.panelSizing, state.criticalData?.session]);
  });
  const originalScope = scope();
  const assertCurrent = () => {
    if (scope() !== originalScope) throw new Error('Account or environment changed; save canceled.');
  };
  let pending = queues.get(dispatch);
  if (!pending) { pending = new Map(); queues.set(dispatch, pending); }
  const next = (pending.get(key) || Promise.resolve()).catch(() => {}).then(() => save(assertCurrent));
  pending.set(key, next);
  const clean = () => { if (pending.get(key) === next) pending.delete(key); };
  next.then(clean, clean);
  return next;
}

export const withoutEditedField = (previous, projectId, fieldName) => {
  const next = { ...previous, [projectId]: { ...previous[projectId] } };
  delete next[projectId][fieldName];
  if (!Object.keys(next[projectId]).length) delete next[projectId];
  return next;
};

const contract = {
  requestCase: 'preserve',
  response: { envelope: [], keepOriginalKeys: true, includeMappedKeys: false },
};

export async function panelRequest(dispatch, method, url, data) {
  const endpoint = { GET: 'getData', POST: 'postData', PATCH: 'patchData' }[method];
  const request = dispatch(portalApi.endpoints[endpoint].initiate(
    { url, data, contract, allowFullPayload: true, requestPolicy: { retry: false } },
    { subscribe: false, forceRefetch: true }
  ));
  try { return await request.unwrap(); }
  finally { request.reset?.(); }
}

export function readPanelRecord(payload, projectId) {
  const rows = Array.isArray(payload) ? payload : Array.isArray(payload?.data) ? payload.data : payload?.ID ? [payload] : null;
  if (!rows || rows.length > 1 || rows.some(row => !row?.ID ||
    (row.ProjectID != null && String(row.ProjectID) !== String(projectId)))) {
    throw new Error('Invalid or ambiguous panel sizing response; save canceled.');
  }
  return rows[0] || null;
}

export async function findPanelRecord(dispatch, url, projectId) {
  // Only a successful, validated empty collection permits creation. A 404,
  // permission error, timeout, or malformed response must not become a POST.
  return readPanelRecord(await panelRequest(dispatch, 'GET', url), projectId);
}

// Compatibility shape for the neighboring review screens while keeping all
// authentication, request policy, and errors in the central portal transport.
export const createPanelTransport = dispatch => ({
  post: (url, data) => panelRequest(dispatch, 'POST', url, data),
  patch: (url, data) => panelRequest(dispatch, 'PATCH', url, data),
});
